enum VehicleSearchStatus {
  IDLE,
  ACTIVE,
  DMS_PROCESSING
}

export default VehicleSearchStatus;